/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Flex, Grid, Heading, jsx } from 'theme-ui'
import { utils } from '@chordcommerce/gatsby-theme-autonomy'
import AttentiveOptIn from '~/components/Attentive/OptIn'

const AttentivePhoneNumberCaptureSection = ({ description, images, title }) => {
  const { getParam } = utils
  const defaultEmailAddress = getParam('email')

  return (
    <Box>
      <Grid columns={[1, 12]} sx={{ rowGap: 0 }}>
        <Flex
          pb={[5, null, 7]}
          pl={[2, 0]}
          pr={[2, 0, 3]}
          pt={[5, null, 6]}
          sx={{
            flexDirection: 'column',
            gridColumn: [null, '3 / 11', '7 / -1'],
            gridRow: [null, '1 / 2'],
            justifyContent: 'center',
            maxWidth: [null, null, '573px'],
          }}
        >
          <Heading as="h1" variant="title2">
            {title}
          </Heading>
          {description && (
            <Box
              sx={{
                variant: 'text.body2',
                a: {
                  variant: 'text.link',
                },
              }}
              dangerouslySetInnerHTML={{
                __html: description.childMarkdownRemark.html,
              }}
            />
          )}
          <AttentiveOptIn
            defaultEmailAddress={defaultEmailAddress}
            defaultOptInValue={true}
            containerBg="backgroundMedium"
            includeEmailAddress={true}
          />
        </Flex>
        {images && (
          <Flex
            sx={{
              gridColumn: [null, '1 / -1', '1 / 7'],
              gridRow: [null, '2 / 3', '1 / 2'],
            }}
          >
            {images.map((image, index) => (
              <GatsbyImage
                image={image.gatsbyImageData}
                key={`image-${index}`}
                alt={image.description}
                style={{ height: 'auto', width: '100%' }}
              />
            ))}
          </Flex>
        )}
      </Grid>
    </Box>
  )
}

export default AttentivePhoneNumberCaptureSection
